export const appName = 'qbm'

export const TIMEZONES_DATA = [
    {id : "-12", text : "(UTC-12)"},
    {id : "-11", text : "(UTC-11)"},
    {id : "-10", text : "(UTC-10)"},
    {id : "-9", text : "(UTC-9)"},
    {id : "-8", text : "(UTC-8)"},
    {id : "-7", text : "(UTC-7)"},
    {id : "-6", text : "(UTC-6)"},
    {id : "-5", text : "(UTC-5)"},
    {id : "-4", text : "(UTC-4)"},
    {id : "-3:30", text : "(UTC-3:30))"},
    {id : "-2", text : "(UTC-2)"},
    {id : "-1", text : "(UTC-1)"},
    {id : "0", text : "(UTC+0)"},
    {id : "+1", text : "(UTC+1)"},
    {id : "+2", text : "(UTC+2)"},
    {id : "+3", text : "(UTC+3)"},
    {id : "+3:30", text : "(UTC+3:30)"},
    {id : "+4", text : "(UTC+4)"},
    {id : "+4:30", text : "(UTC+4:30)"},
    {id : "+5", text : "(UTC+5)"},
    {id : "+5:30", text : "(UTC+5:30)"},
    {id : "+5:45", text : "(UTC+5:45)"},
    {id : "+6", text : "(UTC+6)"},
    {id : "+6:30", text : "(UTC+6:30)"},
    {id : "+7", text : "(UTC+7)"},
    {id : "+8", text : "(UTC+8)"},
    {id : "+8:30", text : "(UTC+8:30)"},
    {id : "+8:45", text : "(UTC+8:45)"},
    {id : "+9", text : "(UTC+9)"},
    {id : "+9:30", text : "(UTC+9:30)"},
    {id : "+10", text : "(UTC+10)"},
    {id : "+10:30", text : "(UTC+10:30)"},
    {id : "+11", text : "(UTC+11)"},
    {id : "+12", text : "(UTC+12)"},
    {id : "+12:45", text : "(UTC+12:45)"},
    {id : "+13", text : "(UTC+13)"},
    {id : "+14", text : "(UTC+14)"},
]

export const LANGUAGE_GUID_MAP = {
    1: {
        id: 1,
        name: "English",
        locale: "en",
        code: 'en-US',
    },
    2: {
        id: 2,
        name: "German",
        locale: "de",
        code: 'de-DE',
    }
}

export const LOADER_BAR_COLOR = "#67d46c"

export const LOADER_BAR_MODAL_SCOPE = 'modal'

export const LOADER_BAR_Q_LOADER_MODAL_SCOPE = 'q-logo-loader-modal'

export const ADMIN_ACCOUNT_NAME = 'ADMIN'


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/settings/constants.js